var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { loadActiveAccount } from '@popup/steem/actions/active-account.actions';
import { loadTokens, loadTokensMarket, loadUserTokens, } from '@popup/steem/actions/token.actions';
import { LocalStorageKeyEnum } from '@reference-data/local-storage-key.enum';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { CheckboxPanelComponent } from 'src/common-ui/checkbox/checkbox-panel/checkbox-panel.component';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { SelectAccountSectionComponent } from 'src/common-ui/select-account-section/select-account-section.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import Config from 'src/config';
import AutomatedTasksUtils from 'src/utils/automatedTasks.utils';
const DEFAULT_SELECTED_TOKEN_OPTION = {
    label: getMessage('popup_html_automated_hive_section_default_option_message'),
    value: '',
};
const AutomatedTasks = ({ accounts, activeAccount, setTitleContainerProperties, }) => {
    const defaultOptions = [];
    const [options, setOptions] = useState(defaultOptions);
    const [claimRewards, setClaimRewards] = useState(false);
    const [claimAccounts, setClaimAccounts] = useState(false);
    const [claimSavings, setClaimSavings] = useState(false);
    const [selectedLocalAccount, setSelectedLocalAccount] = useState(accounts[0].name);
    const [isHiveSectionExpanded, setIsHiveSectionExpanded] = useState(true);
    const claimSavingsErrorMessage = AutomatedTasksUtils.canClaimSavingsErrorMessage(activeAccount);
    const claimAccountErrorMessage = AutomatedTasksUtils.canClaimAccountErrorMessage(activeAccount);
    const claimRewardsErrorMessage = AutomatedTasksUtils.canClaimRewardsErrorMessage(activeAccount);
    useEffect(() => {
        setTitleContainerProperties({
            title: 'popup_html_automated_tasks',
            isBackButtonEnabled: true,
        });
    }, []);
    useEffect(() => {
        init();
        setOptions(accounts.map((account) => {
            return { label: account.name, value: account.name };
        }));
        setSelectedLocalAccount(activeAccount.name);
        loadTokensMarket();
        loadTokens();
    }, [accounts, activeAccount]);
    useEffect(() => {
        if (selectedLocalAccount) {
            loadUserTokens(selectedLocalAccount);
        }
    }, [selectedLocalAccount]);
    const saveClaims = (claimRewards, claimAccounts, claimSavings) => __awaiter(void 0, void 0, void 0, function* () {
        setClaimAccounts(claimAccounts);
        setClaimRewards(claimRewards);
        setClaimSavings(claimSavings);
        yield AutomatedTasksUtils.saveClaims(claimRewards, claimAccounts, claimSavings, activeAccount.name);
    });
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        const values = yield AutomatedTasksUtils.getClaims(activeAccount.name);
        setClaimRewards((_a = values[LocalStorageKeyEnum.CLAIM_REWARDS]) !== null && _a !== void 0 ? _a : false);
        setClaimAccounts((_b = values[LocalStorageKeyEnum.CLAIM_ACCOUNTS]) !== null && _b !== void 0 ? _b : false);
        setClaimSavings((_c = values[LocalStorageKeyEnum.CLAIM_SAVINGS]) !== null && _c !== void 0 ? _c : false);
    });
    const isClaimedAccountDisabled = activeAccount.rc.max_rc < Config.claims.freeAccount.MIN_RC * 1.5;
    return (React.createElement("div", { "data-testid": `${Screen.SETTINGS_AUTOMATED_TASKS}-page`, className: "automated-tasks-page" },
        React.createElement("div", { className: "intro" }, getMessage('popup_html_automated_intro')),
        React.createElement(SelectAccountSectionComponent, { fullSize: true, background: "white" }),
        React.createElement("div", { className: "section" },
            React.createElement("div", { className: "section-expander", onClick: () => setIsHiveSectionExpanded(!isHiveSectionExpanded) },
                React.createElement("div", { className: "section-title-logo" },
                    React.createElement("div", { className: "section-title" }, getMessage('popup_html_automated_hive_section_title'))),
                React.createElement(SVGIcon, { className: "custom-select-handle", icon: isHiveSectionExpanded
                        ? SVGIcons.SELECT_ARROW_UP
                        : SVGIcons.SELECT_ARROW_DOWN })),
            isHiveSectionExpanded && (React.createElement("div", { className: "tasks" },
                React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-autoclaim-rewards", title: "popup_html_enable_autoclaim_rewards", checked: claimRewards, onChange: (value) => saveClaims(value, claimAccounts, claimSavings), hint: "popup_html_enable_autoclaim_rewards_info", tooltipMessage: claimRewardsErrorMessage, disabled: !!claimRewardsErrorMessage }),
                React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-autoclaim-accounts", title: "popup_html_enable_autoclaim_accounts", checked: claimAccounts && !isClaimedAccountDisabled, onChange: (value) => saveClaims(claimRewards, value, claimSavings), skipHintTranslation: true, hint: getMessage('popup_html_enable_autoclaim_accounts_info', [Config.claims.freeAccount.MIN_RC_PCT + '']), tooltipMessage: claimAccountErrorMessage || isClaimedAccountDisabled
                        ? 'popup_html_insufficient_hp_claim_accounts'
                        : undefined, disabled: !!claimSavingsErrorMessage || isClaimedAccountDisabled }),
                React.createElement(CheckboxPanelComponent, { dataTestId: "checkbox-autoclaim-savings", title: "popup_html_enable_autoclaim_savings", checked: claimSavings, onChange: (value) => saveClaims(claimRewards, claimAccounts, value), hint: "popup_html_enable_autoclaim_savings_info", tooltipMessage: claimSavingsErrorMessage, disabled: !!claimSavingsErrorMessage }))))));
};
const mapStateToProps = (state) => {
    return {
        accounts: state.steem.accounts,
        activeAccount: state.steem.activeAccount,
        userTokens: state.steem.userTokens,
        market: state.steem.tokenMarket,
        allTokens: state.steem.tokens,
    };
};
const connector = connect(mapStateToProps, {
    loadActiveAccount,
    setTitleContainerProperties,
    loadUserTokens,
    loadTokensMarket,
    loadTokens,
});
export const AutomatedTasksComponent = connector(AutomatedTasks);
